var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"virtual-scroll",staticClass:"virtual-scroll"},[_c('div',{ref:"virtual-scroll-bar",staticClass:"virtual-scroll-bar"})])}
var staticRenderFns = []

export { render, staticRenderFns }